// src/pages/docs/game/rank.jsx
import { Typography, Box, Link,Button } from '@mui/material';
import DocsLayout from 'layout/DocsLayout';
import commandList from 'data/commands';
import { useLocation } from 'react-router-dom';
import { getAdjacentCommands } from 'components/getAdjacentCommands';

const RankCommand = () => {
  const location = useLocation();
  const command = commandList.find((cmd) => cmd.path === location.pathname);
  const { prev, next } = getAdjacentCommands(location.pathname);

  return (
    <DocsLayout>
      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 4, flexWrap: 'wrap', maxWidth: 800 }}>
        {/* 왼쪽 텍스트 영역 */}
        <Box sx={{ flex: 1, minWidth: 260 }}>
          <Typography variant="h4" fontWeight="bold" gutterBottom>
            /순위
          </Typography>
          <Typography variant="body1" sx={{ mt: -2, mb: 3 }}>
          {command?.description ?? '설명이 없습니다.'}
          </Typography>
          <Typography variant="h6">
            {"사용법: /순위 <전체, 서버, 유저> [페이지 or 유저]"}<br />{"<>는 필수, []는 선택 사항입니다."}
          </Typography>
          <Typography variant="body1" sx={{ mt: 3}}>
          {"예시: /순위 전체 5, /순위 서버, /순위 유저 @티칩"}
          </Typography>
          <Typography variant="body1">
          <br />{"/순위 전체 [페이지]: 전체 순위를 확인합니다."}<br />{"/순위 서버 [페이지]: 서버 순위를 확인합니다."}<br />{"/순위 유저 [유저]: 본인 또는 [유저]의 전체, 서버 순위를 확인합니다."}
          </Typography>
          
        </Box>

        {/* 오른쪽 이미지 영역 */}
        <Box
          component="img"
          src="/commands/rank.webp"
          alt="설명 이미지"
          sx={{
            width: '100%',
            maxWidth: 300,
            borderRadius: 2,
            flexShrink: 0,
            mx: 'auto',
          }}
        />
        <Box
          sx={{
            display: 'flex',
            justifyContent: { xs: 'center', md: 'space-between' },
            gap: 4,
            width: { xs: '100%',md: 'auto' },
            mt:{md:-8}
          }}
        >
        {prev && (
          <Button href={prev.path} variant="outlined"sx={{height: 36, width:118 }}>
            ← {prev.name}
          </Button>
        )}
        {next && (
          <Button href={next.path} variant="outlined"sx={{height: 36, width:118 }}>
            {next.name} →
          </Button>
        )}
        </Box>
      </Box>
    </DocsLayout>
  );
};

export default RankCommand;
